<template>
  <div :style="'top:' + y + 'px; left:' + x + 'px'" :class="{'menu-item': true, 'menu-active': active}" @mouseenter="activate()" @mouseleave="active = false" @click="click()">
    <div :class="{'menu-dot': true, 'menu-dot-active': active}">
      <div :class="{'menu-slant': true, 'menu-slant-active': active}"></div>
      <div class="menu-bar"></div>
      <div class="menu-text"><slot></slot></div>
    </div>
  </div>
</template>

<script async startup>

export default {
  name: 'menu-item',
  props: ['x', 'y', 'click'],
  data () {
    return {
      active: false,
      width: 400
    }
  },
  methods: {
    textWidth () {
      return this.$el.querySelector('.menu-text').clientWidth
    },
    setTextWidth () {
      this.$el.querySelector('.menu-bar').style.maxWidth = this.textWidth() + 15 + 'px'
    },
    activate () {
      this.active = true
      this.setTextWidth()
    }
  },
  watch: {
    x: () => {
      this.setTextWidth()
    }
  },
  mounted () {
    // this.setTextWidth()
  }
}

</script>

<style scoped>
.menu-item {
  min-width: 90px;
  min-height: 90px;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  overflow: visible;
  --item-hover-color: darkgray;
}

.menu-dot {
  border-radius: 100%;
  background-color: var(--item-hover-color);
  opacity: .5;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: auto;
  left: auto;
  animation: dot-shrink .1s linear .3s backwards;
}

@keyframes dot-grow {
  from {
    width: 15px;
  }
  to {
    background-color: rgba(0,0,0,0);
    border: 3px solid var(--item-hover-color);
    width: 50px;
    height: 50px;
    opacity: 1;
  }
}

@keyframes dot-shrink {
  from {
    background-color: rgba(0,0,0,0);
    border: 3px solid var(--item-hover-color);
    width: 50px;
    height: 50px;
    opacity: 1;
  }
  to {
    width: 15px;
  }
}

.menu-dot-active {
  animation: dot-grow .1s linear 0s forwards;
}

.menu-slant {
  height: 3px;
  width: 0px;
  margin-top: 100px;
  background: var(--item-hover-color);
  transform: rotate(-45deg);
  transform-origin: left;
  transition: all .2s;
  transition-delay: .2s;
  position: absolute;
  bottom: 28px;
  left: 52px;
  animation: slant-shrink .1s linear .2s both;
}

@keyframes slant-grow {
  from {
    width: 0px;
  }
  to {
    width: 50px;
  }
}

@keyframes slant-shrink {
  from {
    width: 50px;
  }
  height {
    width: 0px;
  }
}

.menu-slant-active {
  animation: slant-grow .1s linear .1s forwards;
}

.menu-bar {
  border-top: 3px solid var(--item-hover-color);
  height: 0px;
  width: 0px;
  position: absolute;
  bottom: 63px;
  left: 87px;
  animation: bar-shrink .2s linear 0s forwards;
}

@keyframes bar-grow {
  from {
    width: 0px;
  }
  to {
    width: 4000px;
  }
}

@keyframes bar-shrink {
  from {
    width: 40000px;
  }
  to {
    width: 0px;
  }
}

.menu-dot-active > .menu-bar {
  animation: bar-grow .2s linear .2s forwards;
}

.menu-text {
  color: var(--item-hover-color);
  transition: all .5s;
  font-size: 20px;
  position: absolute;
  top: -7px;
  left: 95px;
  font-family:Arial, sans-serif;
  width: auto;
  height: auto;
  shape-outside: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  clip-path: inset(0 100% 0 0);
  animation: text-shrink .2s linear 0s forwards;
  white-space: nowrap;
  position: absolute;
}

@keyframes text-grow {
  0% {
    clip-path: inset(0 100% 0 0);
  }
  100% {
    clip-path: inset(0 0 0 0);
  }
}

@keyframes text-shrink {
  0% {
    clip-path: inset(0 0 0 0);
  }
  100% {
    clip-path: inset(0 100% 0 0);
  }
}

.menu-dot-active > .menu-text {
  animation: text-grow .2s linear .2s forwards;
}
</style>



// WEBPACK FOOTER //
// src/components/menu-item.vue